'use client';

import { styled } from 'styled-components';
import { WistiaChannel } from '@wistia/react-embeds';

/**
 * Full-bleed, native-styled channel embed for /series detail pages.
 *
 * We intentionally do NOT use the DVD `Channel` component here: it injects a
 * global `ChannelTheme` that forces `.w-gallery-view { background: none }` and
 * strips gallery card background-images — a workaround for placing a channel on
 * a light DVD page. A series detail page IS the channel, so we want its native
 * styling (including its dark background and card art) to render exactly as
 * authored, edge to edge, like the legacy page.
 */
const FullBleedChannel = styled.div`
  overflow: hidden;
  width: 100%;

  .wistia_channel {
    width: 100%;
  }
`;

const SeriesChannel = ({ hashedId }: { hashedId: string }) => (
  <FullBleedChannel>
    <WistiaChannel hashedId={hashedId} mode="inline" />
  </FullBleedChannel>
);

export default SeriesChannel;
